import { Injectable } from '@angular/core';

import { CompaniesViewModel } from '@/app/Ui/ViewModels/companiesViewModel';
import { ContactsViewModel } from '@/app/Ui/ViewModels/contactsViewModel';
import { ITaskRepository } from '@/app/core/IRepositories/ITaskepository';

import { UseCase } from '../UseCase';
import { TaskDetail } from '@/app/core/Models/Task';
import { CreatTaskDto } from '@/app/Data/DTO/TaskDto';

import { Observable, tap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class EditTaskUseCase implements UseCase<CreatTaskDto, TaskDetail> {
  constructor(
    private taskRepository: ITaskRepository,
    private companiesViewModel: CompaniesViewModel,
    private contactsViewModel: ContactsViewModel
  ) { }

  execute(request: CreatTaskDto): Observable<TaskDetail> {
    return this.taskRepository.editTask(request.task, request.taskId!).pipe(
      tap(async (task) => {
        this.readAssociatedTasks(request);
        this.taskRepository.saveTaskDetail(task);
        this.taskRepository.isUnread().subscribe();
      })
    );
  }

  readAssociatedTasks(request: CreatTaskDto): void {
    if (request.task.yobi_crm_company_id) this.companiesViewModel.getCompanyTasks({ page: 1, page_size: 20, companyId: request.task.yobi_crm_company_id as string });
    if (request.task.contact_id) this.contactsViewModel.getContactTasks({ page: 1, page_size: 20, contact_id: request.task.contact_id as string });
  }

}
